export default __webpack_public_path__ + "static/media/francheville22.d1c37198.jpg";